import { walk } from 'estree-walker';
import is_reference from 'is-reference';

function analyze(expression) {
	const map = new WeakMap();

	let scope = new Scope(null, false);

	walk(expression, {
		enter(node, parent) {
			if (node.type === 'ImportDeclaration') {
				node.specifiers.forEach((specifier) => {
					scope.declarations.set(specifier.local.name, specifier);
				});
			} else if (/(Function(Declaration|Expression)|ArrowFunctionExpression)/.test(node.type)) {
				if (node.type === 'FunctionDeclaration') {
					scope.declarations.set(node.id.name, node);
					map.set(node, scope = new Scope(scope, false));
				} else {
					map.set(node, scope = new Scope(scope, false));
					if (node.type === 'FunctionExpression' && node.id) scope.declarations.set(node.id.name, node);
				}

				node.params.forEach((param) => {
					extract_names(param).forEach(name => {
						scope.declarations.set(name, node);
					});
				});
			} else if (/For(?:In|Of)?Statement/.test(node.type)) {
				map.set(node, scope = new Scope(scope, true));
			} else if (node.type === 'BlockStatement') {
				map.set(node, scope = new Scope(scope, true));
			} else if (/(Class|Variable)Declaration/.test(node.type)) {
				scope.add_declaration(node);
			} else if (node.type === 'CatchClause') {
				map.set(node, scope = new Scope(scope, true));

				if (node.param) {
					extract_names(node.param).forEach(name => {
						scope.declarations.set(name, node.param);
					});
				}
			}
		},

		leave(node) {
			if (map.has(node)) {
				scope = scope.parent;
			}
		}
	});

	const globals = new Map();

	walk(expression, {
		enter(node, parent) {
			if (map.has(node)) scope = map.get(node);

			if (node.type === 'Identifier' && is_reference(node, parent)) {
				const owner = scope.find_owner(node.name);
				if (!owner) globals.set(node.name, node);

				add_reference(scope, node.name);
			}
		},
		leave(node) {
			if (map.has(node)) {
				scope = scope.parent;
			}
		}
	});

	return { map, scope, globals };
}

function add_reference(scope, name) {
	scope.references.add(name);
	if (scope.parent) add_reference(scope.parent, name);
}

class Scope {
	
	
	__init() {this.declarations = new Map();}
	__init2() {this.initialised_declarations = new Set();}
	__init3() {this.references = new Set();}

	constructor(parent, block) {Scope.prototype.__init.call(this);Scope.prototype.__init2.call(this);Scope.prototype.__init3.call(this);
		this.parent = parent;
		this.block = block;
	}


	add_declaration(node) {
		if (node.type === 'VariableDeclaration') {
			if (node.kind === 'var' && this.block && this.parent) {
				this.parent.add_declaration(node);
			} else if (node.type === 'VariableDeclaration') {
				node.declarations.forEach((declarator) => {
					extract_names(declarator.id).forEach(name => {
						this.declarations.set(name, node);
						if (declarator.init) this.initialised_declarations.add(name);
					});
				});
			}
		} else {
			this.declarations.set(node.id.name, node);
		}
	}

	find_owner(name) {
		if (this.declarations.has(name)) return this;
		return this.parent && this.parent.find_owner(name);
	}

	has(name) {
		return (
			this.declarations.has(name) || (this.parent && this.parent.has(name))
		);
	}
}

function extract_names(param) {
	return extract_identifiers(param).map(node => node.name);
}

function extract_identifiers(param) {
	const nodes = [];
	extractors[param.type] && extractors[param.type](nodes, param);
	return nodes;
}

const extractors = {
	Identifier(nodes, param) {
		nodes.push(param);
	},

	MemberExpression(nodes, param) {
		let object = param;
		while (object.type === 'MemberExpression') object = object.object;
		nodes.push(object);
	},

	ObjectPattern(nodes, param) {
		param.properties.forEach((prop) => {
			if (prop.type === 'RestElement') {
				nodes.push(prop.argument);
			} else {
				extractors[prop.value.type](nodes, prop.value);
			}
		});
	},

	ArrayPattern(nodes, param) {
		param.elements.forEach((element) => {
			if (element) extractors[element.type](nodes, element);
		});
	},

	RestElement(nodes, param) {
		extractors[param.argument.type](nodes, param.argument);
	},

	AssignmentPattern(nodes, param) {
		extractors[param.left.type](nodes, param.left);
	}
};

export { analyze, Scope, extract_names, extract_identifiers };
